// @vendors
import React from 'react'
import { useTranslation } from 'react-i18next';
import { PhotoIcon } from '@heroicons/react/24/solid';
import { toast } from 'react-toastify';

// @store
import { useSpinnerStore } from '../../../../store/useSpinnerStore';

// @services
import professionalService from "../../../../services/professional.service";

// @helper
import { IDocumentsProfessional } from '../../../../types/professional.types';

interface IItemDocuments {
    getDocuments: Function;
    documentFile: IDocumentsProfessional | null;
    documentName: string;
    documentNumber: string;
}

const ItemDocument: React.FC<IItemDocuments> = ({
    documentFile,
    getDocuments,
    documentName,
    documentNumber
}) => {
    const { t } = useTranslation();
    const { openSpinner } = useSpinnerStore();

    const uploadDocument = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files) return;
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append('files', file);
        formData.append('documentTypes', documentNumber);
        submitDocumnet(formData);
    }

    const submitDocumnet = async (file: FormData) => {
        openSpinner(true);
        try {
            await professionalService.uploadDocumentFromDashboard(file);
            getDocuments();
            openSpinner(false);
        } catch (error) {
            openSpinner(false);
            toast.error(t("error.postData"));
        }
    }

    const downloadDocument = async () => {
        openSpinner(true);
        try {
            const response = await professionalService.downloadDocuments(documentFile?.documentId ?? '');
            successDownload(response, documentFile?.documentName ?? '');
            openSpinner(false);
        } catch (error) {
            openSpinner(false);
            toast.error(t("error.errorImage"));
        }
    }

    const successDownload = (response: any, documentName: string) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", documentName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Eliminar el enlace después de la descarga
        window.URL.revokeObjectURL(url); // Liberar memoria
        toast.success(t("professional.profile.succesDownload"));
    }

    return (
        <div className="flex flex-col lg:flex-row justify-between items-center border-b dark:border-white/20 pb-2" >
            <div className='flex gap-[10px] items-center'>
                <PhotoIcon className='w-7 text-[#F97068]' />
                <p className="text-gray-700 dark:text-dark-cText/70 text-sm">{documentName}</p>
            </div>

            {documentFile === null
                ? <label htmlFor={`upload-document-company-${documentName}`}>
                    <p className="text-[#7784EE] text-sm">
                        {t("professional.profile.upload")}
                    </p>

                    <input
                        id={`upload-document-company-${documentName}`}
                        type="file"
                        accept="image/*"
                        className="hidden"
                        onChange={uploadDocument}
                    />
                </label>
                : <button
                    className="text-[#7784EE] text-sm"
                    onClick={() => downloadDocument()}
                >
                    {t("professional.profile.download")}
                </button>
            }
        </div>
    )
}

export default ItemDocument